import React       from 'react';
import LoadingIcon from './KirokuLoading';

export default function KirokuLoader({ loading, children, ComponentLoading = LoadingIcon }) {
    return loading ? <ComponentLoading/> : children;
}

